import { render } from "./LocalInfo.vue?vue&type=template&id=7a6c1019&scoped=true"
import script from "./LocalInfo.vue?vue&type=script&lang=js"
export * from "./LocalInfo.vue?vue&type=script&lang=js"

import "./LocalInfo.vue?vue&type=style&index=0&id=7a6c1019&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6c1019"]])

export default __exports__